import React from 'react';

import Loading from 'assets/svg/loader_big.component.svg';
import './loading-big-icon.scss';

const LoadingIcon = () => <div styleName="loading"><Loading /></div>;

export default LoadingIcon;
